import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import Styles from "./AvailableListing.module.css";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMatchmakingResults,
  setCounterPartyListingId,
  fetchBankingReceived,
  fetchDocumentUrlByLedgerId,
  clearMatchmakingData,
  fetchActiveLedger,
  fetchAllBankingListings,
} from "../../../../Redux/Slices/bankingSlice";
import ConnectModalBanking from "../../../Modals/Banking/ConnectModal/ConnectModalBanking";
import ViewInjectionModal from "../../../Modals/Banking/ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../../Modals/Banking/ViewDrawalModal/ViewDrawalModal";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { ReactComponent as AccessTimeIcon } from "../../../../assets/images/AccessTimeIcon.svg";
import ViewInjectDrawal from "../../../Modals/Banking/ViewInjectDrawal/ViewInjectDrawal";
import AvailableListingSkeleton from "../../../../commons/AvailableListingSkeleton";
import Loader from "../../../../commons/Loader/Loader";
import NoDataPage from "../../NoDataPage/NoDataPage";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import ViewModalReceived from "../../../Modals/Banking/ViewModalReceived/ViewModalReceived";
import TermsConditionModal from "../../../Modals/Banking/TermsConditionModal/TermsConditionModal";
import UploadDocModal from "../../../Modals/Banking/UploadDocModal/UploadDocModal";
import ViewDoc from "../../../Modals/Banking/ViewDoc/ViewDoc";
import UpdateLedger from "../../../Modals/Banking/UpdateLedger/UpdateLedger";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import ContractViewContainer from "../../../ContractCalculator/ContractViewContainer";
import { connectionClose } from "../../../../Services/ApiCalling/banking";
import ClosePopup from "../../../../commons/PopupModal/BankingPopup/ClosePopup/ClosePopup";
import ViewProfile from "../../../Modals/Banking/ViewProfile/ViewProfile";
import { openBilateralChat } from "../../../Modals/Banking/CreateEdit/helpers";
import DirectDocumentation from "../../../Modals/Common/DirectDocumentation/DirectDocumentation";

const AvailableListing = ({
  expirySortDir,
  selfListings,
  activeFilter,
  onCountChange,
  appliedFilters,
  hideViewProfile = false,
}) => {
  const [connectModal, setConnectModal] = useState({
    open: false,
    isConnected: false,
  });
  const dispatch = useDispatch();

  const activeListingId = useSelector(
    (state) => state.bankingSlice.activeListingId,
  );
  const activeListing = useSelector(
    (state) => state.bankingSlice?.activeLedgerData[0]?.selfListing,
  );

  const bankingState = useSelector((state) => state?.bankingSlice || {});
  const allListings = bankingState.allListings || [];

  const userData = useSelector((state) => state.persistedReducer);

  const counterPartyListingId = useSelector(
    (state) => state.bankingSlice.counterPartyListingId,
  );
  const { matchmakingData } = useSelector((state) => state.bankingSlice);
  // notificationState selector removed (not used in this component)

  const mixedMatches = useMemo(() => {
    return [...(matchmakingData?.matches || [])].filter((item) => item != null);
  }, [matchmakingData?.matches]);

  const [injectionOpen, setInjectionOpen] = useState(false);

  const [selectedListing, setSelectedListing] = useState(null);
  const [injectData, setInjectData] = useState([]);
  const [viewInjectDrawalOpen, setViewInjectDrawalOpen] = useState(false);
  const [viewInjectDrawalData, setViewInjectDrawalData] = useState([]);
  const [indentsModal, setIndentsModal] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewDocumentId, setPreviewDocumentId] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [initiatorListing, setInitiatorListing] = useState(null);
  const [activeLedgerData, setActiveLedgerData] = useState([]);
  const [termsModal, setTermsModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedConnection, setSelectedConnection] = useState(null);

  const [selectedCounterparty, setSelectedCounterparty] = useState(null);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [modalApprovalMode, setModalApprovalMode] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [viewDocConnectionId, setViewDocConnectionId] = useState(null);
  const [activeViewCounterparty, setActiveViewCounterparty] = useState(null);
  const [updateLedgerModalOpen, setUpdateLedgerModalOpen] = useState(false);
  const [isClosePopupOpen, setIsClosePopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null);
  const [viewProOpen, setViewProOpen] = useState(false);
  const [matches] = useState([]);

  const [updateLedgerConnectionId, setUpdateLedgerConnectionId] =
    useState(null);
  const [updateLedgerSelfListingId, setUpdateLedgerSelfListingId] =
    useState(null);
  const [updateLedgerConnectionData, setUpdateLedgerConnectionData] =
    useState(null);
  const [closeableConnections, setCloseableConnections] = useState(new Set());
  // eslint-disable-next-line no-unused-vars
  const [ledgerActiveConnections, setLedgerActiveConnections] = useState(
    new Set(),
  );

  const [combinedLoading, setCombinedLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [lastFetchRef, setLastFetchRef] = useState(null);
  const lastProcessedNotificationRef = useRef(null);
  const lastMatchesFetchRef = useRef(null);

  const handlesetInitiatorListing = ({ item }) => {
    setInitiatorListing(item?.connectionInitiatorListingId);
  };

  const performFetchMatchmakingResults = useCallback(
    async ({ id, statusFilter = null, ...opts } = {}) => {
      const force = opts?.force || false;
      if (!id) return null;

      if (!force && lastMatchesFetchRef.current === id) return null;
      lastMatchesFetchRef.current = id;

      try {
        const res = await dispatch(
          fetchMatchmakingResults({ id, statusFilter, ...opts }),
        );
        return res;
      } catch (err) {
        if (lastMatchesFetchRef.current === id)
          lastMatchesFetchRef.current = null;
        throw err;
      }
    },
    [dispatch],
  );

  useEffect(() => {
    // reset the last matches fetch marker when active listing changes
    lastMatchesFetchRef.current = null;
  }, [activeListingId]);

  const parseDMY = useCallback((str) => {
    if (!str) return null;
    const datePart = String(str).trim().split(" ")[0];
    const [dd, mmm, yyyy] = datePart.split("-");
    const months = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
      JAN: 0,
      FEB: 1,
      MAR: 2,
      APR: 3,
      MAY: 4,
      JUN: 5,
      JUL: 6,
      AUG: 7,
      SEP: 8,
      OCT: 9,
      NOV: 10,
      DEC: 11,
    };
    const month = months[mmm];
    const day = parseInt(dd, 10);
    const year = parseInt(yyyy, 10);
    if (Number.isNaN(day) || Number.isNaN(year) || month == null) return null;
    return new Date(year, month, day);
  }, []);

  const startOfDay = useCallback(
    (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()),
    [],
  );

  const addDays = useCallback((d, days) => {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    return x;
  }, []);

  const getMaxEndDate = useCallback(
    (counterParties) => {
      const injectDates = [];
      const drawalDates = [];

      counterParties.forEach((cp) => {
        cp?.finalizedConnectionValues?.slotInjects?.forEach((inject) => {
          if (inject?.dateEndAt) {
            injectDates.push(parseDMY(inject.dateEndAt));
          }
        });
        cp?.finalizedConnectionValues?.slotDrawls?.forEach((drawal) => {
          if (drawal?.dateEndAt) {
            drawalDates.push(parseDMY(drawal.dateEndAt));
          }
        });
      });

      const allDates = [...injectDates, ...drawalDates].filter(Boolean);
      if (allDates.length === 0) return null;
      return allDates.reduce((a, b) => (a > b ? a : b));
    },
    [parseDMY],
  );

  const getMinStartDate = useCallback(
    (counterParties) => {
      const injectDates = [];
      const drawalDates = [];

      counterParties.forEach((cp) => {
        cp?.finalizedConnectionValues?.slotInjects?.forEach((inject) => {
          if (inject?.dateStartAt) {
            injectDates.push(parseDMY(inject.dateStartAt));
          }
        });
        cp?.finalizedConnectionValues?.slotDrawls?.forEach((drawal) => {
          if (drawal?.dateStartAt) {
            drawalDates.push(parseDMY(drawal.dateStartAt));
          }
        });
      });

      const allDates = [...injectDates, ...drawalDates].filter(Boolean);
      if (allDates.length === 0) return null;
      return allDates.reduce((a, b) => (a < b ? a : b));
    },
    [parseDMY],
  );

  const canShowClose = useCallback(
    (connectionDetails) => {
      const maxEndDate = getMaxEndDate(connectionDetails);
      if (!maxEndDate) return false;

      const closeActiveDate = addDays(startOfDay(maxEndDate), 1);
      return startOfDay(new Date()) >= closeActiveDate;
    },
    [getMaxEndDate, addDays, startOfDay],
  );

  const canShowLedger = useCallback(
    (connectionDetails) => {
      const minStartDate = getMinStartDate(connectionDetails);
      if (!minStartDate) return false;

      const ledgerActiveDate = startOfDay(minStartDate);
      return startOfDay(new Date()) >= ledgerActiveDate;
    },
    [getMinStartDate, startOfDay],
  );

  const handleCloseView = useCallback(() => {
    setViewModal(false);
    setSelectedItem(null);
  }, []);

  const fetchCombinedData = useCallback(
    async (force = false) => {
      if (!activeListingId) {
        dispatch(clearMatchmakingData());
        setActiveLedgerData([]);
        return;
      }

      if (isFetching && !force) {
        return;
      }

      const now = Date.now();
      if (lastFetchRef && now - lastFetchRef < 500 && !force) {
        return;
      }

      setIsFetching(true);
      setLastFetchRef(now);
      setCombinedLoading(true);

      try {
        const [, activeLedgerResult] = await Promise.all([
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: activeFilter,
          }),
          dispatch(
            fetchActiveLedger({
              currentPage: 0,
              size: 20,
              bankingListingId: activeListingId,
            }),
          ),
        ]);

        if (fetchActiveLedger.fulfilled.match(activeLedgerResult)) {
          setActiveLedgerData(activeLedgerResult.payload || []);
        } else {
          setActiveLedgerData([]);
        }

        if (isInitialLoad) {
          setIsInitialLoad(false);
        }
      } catch (error) {
        setActiveLedgerData([]);
      } finally {
        setCombinedLoading(false);
        setIsFetching(false);
      }
    },
    [
      dispatch,
      activeListingId,
      activeFilter,
      isFetching,
      lastFetchRef,
      isInitialLoad,
      performFetchMatchmakingResults,
    ],
  );

  const notifications = useSelector(
    (state) => state?.notificationSlice?.notifications || [],
  );

  useEffect(() => {
    if (activeListingId && notifications.length > 0) {
      const latestNotification = notifications[notifications.length - 1];
      const notificationId =
        latestNotification?.id || JSON.stringify(latestNotification);

      if (lastProcessedNotificationRef.current === notificationId) {
        return;
      }

      if (
        latestNotification?.data?.key &&
        latestNotification.data.key.startsWith("BANKING")
      ) {
        lastProcessedNotificationRef.current = notificationId;
        const notificationCacheBuster = Date.now();

        const timeoutId = setTimeout(() => {
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: null,
            _cacheBust: notificationCacheBuster,
            _hardRefresh: true,
            _notificationTriggered: true,
            force: true,
          });

          dispatch(
            fetchAllBankingListings({
              _cacheBust: notificationCacheBuster,
              _hardRefresh: true,
            }),
          );

          setTimeout(() => {
            fetchCombinedData(true);
          }, 100);
        }, 300);

        return () => clearTimeout(timeoutId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications.length, activeListingId, dispatch]);

  const handleConnectionAccepted = useCallback(() => {
    setViewModal(false);
    setSelectedItem(null);
    fetchCombinedData();
  }, [fetchCombinedData]);

  const handleConnectionDeclined = useCallback(() => {
    setViewModal(false);
    setSelectedItem(null);
    fetchCombinedData();
  }, [fetchCombinedData]);

  const handleOpenModal = async (
    connection,
    counterparty,
    { viewOnly = false, isApprovalMode = false } = {},
  ) => {
    setModalLoading(true);

    if (activeListingId) {
      try {
        const preMdalCacheBuster = Date.now();

        const recentNotifications = notifications.slice(-5);
        const hasRecentBankingNotification = recentNotifications.some(
          (notification) =>
            notification?.data?.key &&
            notification.data.key.startsWith("BANKING") &&
            (notification.data.data?.listingId === activeListingId ||
              notification.data.data?.id === counterparty?.id ||
              notification.data.data?.id === connection?.id),
        );

        if (hasRecentBankingNotification) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }

        await Promise.all([
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: null,
            _cacheBust: preMdalCacheBuster,
            _hardRefresh: true,
            _preModalRefresh: true,
            force: true,
          }),
          dispatch(
            fetchAllBankingListings({
              _cacheBust: preMdalCacheBuster,
              _hardRefresh: true,
            }),
          ),
        ]);

        await fetchCombinedData();

        const delayTime = hasRecentBankingNotification ? 2000 : 1500;
        await new Promise((resolve) => setTimeout(resolve, delayTime));
      } catch (error) {}
    }

    let updatedConnection = connection;
    let updatedCounterparty = counterparty;

    if (connection?.id && activeLedgerData?.length > 0) {
      const freshConnection = activeLedgerData.find(
        (conn) =>
          conn.id === connection.id ||
          conn.counterPartyListings?.some((cp) => cp.id === counterparty?.id),
      );
      if (freshConnection) {
        updatedConnection = freshConnection;
        if (counterparty?.id) {
          const freshCounterparty = freshConnection.counterPartyListings?.find(
            (cp) => cp.id === counterparty.id,
          );
          if (freshCounterparty) {
            updatedCounterparty = freshCounterparty;
          }
        }
      }
    }

    if (counterparty?.id && matchmakingData?.matches) {
      const freshMatch = matchmakingData.matches.find(
        (match) => match?.id === counterparty.id,
      );
      if (freshMatch) {
        updatedCounterparty = { ...updatedCounterparty, ...freshMatch };
      }
    }

    setModalLoading(false);
    setSelectedConnection(updatedConnection);
    setSelectedCounterparty(updatedCounterparty);
    setModalViewOnly(viewOnly);
    setModalApprovalMode(isApprovalMode);
    setTermsModal(true);
  };

  const handleCloseModal = () => setTermsModal(false);

  const handleAccepted = async (id) => {
    handleCloseModal();

    dispatch(clearMatchmakingData());

    if (activeListingId) {
      const refreshCacheBuster = Date.now();

      try {
        await Promise.all([
          fetchCombinedData(),
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: activeFilter,
            _cacheBust: refreshCacheBuster,
            _hardRefresh: true,
            _termsActionCompleted: true,
            force: true,
          }),
          dispatch(
            fetchAllBankingListings({
              _cacheBust: refreshCacheBuster,
              _hardRefresh: true,
              _termsActionCompleted: true,
            }),
          ),
        ]);
      } catch (error) {}
    } else {
      await fetchCombinedData();
    }
  };

  const handleDeclined = async (id) => {
    handleCloseModal();

    dispatch(clearMatchmakingData());
    if (activeListingId) {
      const refreshCacheBuster = Date.now();

      try {
        await Promise.all([
          fetchCombinedData(),
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: activeFilter,
            _cacheBust: refreshCacheBuster,
            _hardRefresh: true,
            _termsActionCompleted: true,
            force: true,
          }),
          dispatch(
            fetchAllBankingListings({
              _cacheBust: refreshCacheBuster,
              _hardRefresh: true,
              _termsActionCompleted: true,
            }),
          ),
        ]);
      } catch (error) {}
    } else {
      await fetchCombinedData();
    }
  };

  const handleChatOpen = (fromUser, toUser, initId) => {
    let chatId;

    if (fromUser === initId) {
      chatId = `${fromUser?.split("_")?.[0]}_${toUser?.split("_")?.[0]}`;
    } else {
      chatId = `${toUser?.split("_")?.[0]}_${fromUser?.split("_")?.[0]}`;
    }

    openBilateralChat(dispatch, {
      header: toUser,
      fromUser,
      toUser,
      chatId,
    });
  };

  const handleAcceptAgreementClick = async (item) => {
    setModalLoading(true);
    try {
      // Force-refresh activeLedgerData before opening modal
      const activeLedgerResult = await dispatch(
        fetchActiveLedger({
          currentPage: 0,
          size: 20,
          bankingListingId: activeListingId,
        }),
      );

      let freshLedgerData = activeLedgerData;
      if (fetchActiveLedger.fulfilled.match(activeLedgerResult)) {
        freshLedgerData = activeLedgerResult.payload || [];
        setActiveLedgerData(freshLedgerData);
      }

      // Now resolve connection/counterparty from FRESH ledger data
      const freshConnection = freshLedgerData.find(
        (conn) =>
          conn.id === item?.connectionDetails?.[0]?.id ||
          conn.counterPartyListings?.some((cp) => cp.id === item.id),
      );

      if (freshConnection) {
        const freshCounterparty = freshConnection.counterPartyListings?.find(
          (cp) => cp.id === item.id,
        );
        handleUploadModalOpen(freshConnection, freshCounterparty || item);
      } else {
        // Fallback: use item's connectionDetails
        const connectionDetail = item.connectionDetails?.[0];
        const fallbackConnection = {
          id: connectionDetail?.id || item.id,
          selfListing: item,
          counterPartyListings: [
            {
              id: item.id,
              name: item.name,
              companyName: item.companyName,
              userId: item.userId,
              connectionId: connectionDetail?.id,
              connectionStatus: item.status,
              ...connectionDetail,
            },
          ],
        };
        const fallbackCounterparty = {
          id: item.id,
          name: item.name,
          companyName: item.companyName,
          userId: item.userId,
          connectionId: connectionDetail?.id,
          connectionStatus: item.status,
          bankingFactor: item.bankingFactor,
          settlementRate: item.settlementRate,
          maxInjectQuantity: item.maxInjectQuantity,
          minInjectQuantity: item.minInjectQuantity,
          maxDrawalQuantity: item.maxDrawalQuantity,
          minDrawalQuantity: item.minDrawalQuantity,
          bankingSlotInjects: item.bankingSlotInjects,
          bankingSlotDrawls: item.bankingSlotDrawls,
          ...connectionDetail,
        };
        handleUploadModalOpen(fallbackConnection, fallbackCounterparty);
      }
    } catch (error) {
      // Fallback: open with existing data
      const connectionDetails = getActiveConnectionDetails(item);
      if (connectionDetails) {
        handleUploadModalOpen(
          connectionDetails.connection,
          connectionDetails.counterparty,
        );
      }
    } finally {
      setModalLoading(false);
    }
  };

  const handleUploadModalOpen = (connection, counterparty) => {
    setSelectedConnection(connection);
    setSelectedCounterparty(counterparty);
    setUploadModal(true);
  };

  const handleUploadClose = () => {
    setUploadModal(false);

    const isSafeToRefresh =
      activeListingId &&
      matchmakingData?.selfListing?.id === activeListingId &&
      activeLedgerData.length > 0;

    if (isSafeToRefresh) {
      fetchCombinedData();
    } else {
      if (activeListingId) {
        performFetchMatchmakingResults({
          id: activeListingId,
          statusFilter: activeFilter,
        }).catch((error) => {});
      }
    }
  };

  const handleOpenViewDoc = (connectionId, counterparty) => {
    setViewDocConnectionId(connectionId);
    setActiveViewCounterparty(counterparty);
    setViewDocModalOpen(true);
  };

  const handleCloseViewDoc = () => {
    setViewDocModalOpen(false);
    setViewDocConnectionId(null);
  };

  const handleOpenUpdateLedger = (
    connectionId,
    selfListingId = null,
    connectionData = null,
  ) => {
    const finalSelfListingId = selfListingId || activeListingId;
    setUpdateLedgerConnectionId(connectionId);
    setUpdateLedgerSelfListingId(finalSelfListingId);
    setUpdateLedgerConnectionData(connectionData);
    setUpdateLedgerModalOpen(true);
  };

  const handleCloseUpdateLedger = () => {
    setUpdateLedgerModalOpen(false);
    setUpdateLedgerConnectionId(null);
    setUpdateLedgerSelfListingId(null);
    setUpdateLedgerConnectionData(null);
  };

  const handleLedgerUpdated = useCallback(() => {
    fetchCombinedData();
  }, [fetchCombinedData]);

  // eslint-disable-next-line no-unused-vars
  const handleCloseConnection = (connectionId) => {
    if (!connectionId) return;

    connectionClose(connectionId)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {});
  };

  // eslint-disable-next-line no-unused-vars
  const handleTermsInitiatedApproval = (item) => {
    try {
      const connectionDetails = getActiveConnectionDetails(item);

      if (!connectionDetails) {
        handleOpenViewModalReceived(item);
        return;
      }

      const { connection: conn, counterparty } = connectionDetails;

      handleOpenModal(conn, counterparty, {
        viewOnly: false,
        isApprovalMode: true,
      });
    } catch (error) {
      handleOpenViewModalReceived(item);
    }
  };

  const getActiveConnectionDetails = useCallback(
    (item) => {
      try {
        if (!item?.id) {
          return null;
        }

        const connection = activeLedgerData.find((conn) =>
          conn.counterPartyListings?.some((cp) => cp.id === item.id),
        );

        if (connection) {
          const counterparty = connection.counterPartyListings.find(
            (cp) => cp.id === item.id,
          );

          return { connection, counterparty };
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    [activeLedgerData],
  );

  const handleCloseInjection = () => {
    setInjectionOpen(false);
    setInjectData([]);
  };

  const handleOpenViewInjectDrawal = (item) => {
    setViewInjectDrawalData([item]);
    setViewInjectDrawalOpen(true);
  };

  const handleCloseViewInjectDrawal = () => {
    setViewInjectDrawalOpen(false);
    setViewInjectDrawalData([]);
  };

  const [drawalOpen, setDrawalOpen] = useState(false);
  const [drawalData, setDrawalData] = useState([]);

  const handleCloseDrawal = () => {
    setDrawalOpen(false);
    setDrawalData([]);
  };

  const prevActiveFilterRef = useRef(activeFilter);

  useEffect(() => {
    if (activeListingId) {
      const filterChanged = prevActiveFilterRef.current !== activeFilter;
      prevActiveFilterRef.current = activeFilter;

      fetchCombinedData(filterChanged);
    }
  }, [activeListingId, activeFilter, fetchCombinedData]);

  const bankingSliceState = useSelector((state) => state.bankingSlice);
  useEffect(() => {
    if (
      activeListingId &&
      bankingSliceState?.activeListingId === activeListingId &&
      !isFetching
    ) {
      // Only dispatch if the fetched selfListing doesn't match current listing
      // and we haven't just fetched for this listing — prevents loops.
      if (
        matchmakingData?.selfListing?.id !== activeListingId &&
        lastMatchesFetchRef.current !== activeListingId
      ) {
        lastMatchesFetchRef.current = activeListingId;
        const timeoutId = setTimeout(() => {
          performFetchMatchmakingResults({
            id: activeListingId,
            statusFilter: activeFilter,
          });
        }, 300);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [
    activeListingId,
    matchmakingData?.selfListing?.id,
    dispatch,
    activeFilter,
    bankingSliceState?.activeListingId,
    isFetching,
    performFetchMatchmakingResults,
  ]);

  const handleOpenConnect = (item, isConnected) => {
    dispatch(setCounterPartyListingId(item?.id));
    setConnectModal({ open: true, isConnected });
  };

  const handleCloseConnect = () => {
    setConnectModal({ open: false, isConnected: false });
  };

  const getConnectionStatus = (counterPartyId) => {
    const connection = mixedMatches.find(
      (match) =>
        match &&
        (match.id === counterPartyId ||
          match.counterPartyListingId === counterPartyId ||
          match.bankingListingId === counterPartyId ||
          match.againstBankingListingId === counterPartyId),
    );

    if (connection) return connection;

    const matchWithConnection = allListings?.find((match) => {
      if (match.id === counterPartyId && match.connectionDetails?.length > 0) {
        return match.connectionDetails[0];
      }
      return null;
    });

    if (matchWithConnection?.connectionDetails?.length > 0) {
      const connectionDetail = matchWithConnection.connectionDetails[0];

      return {
        ...connectionDetail,
        matchData: matchWithConnection,
      };
    }

    return null;
  };

  const isConnectionEstablished = (counterPartyId) => {
    const connection = getConnectionStatus(counterPartyId);
    return ["PLACED", "RECEIVED", "LEDGER"].includes(connection?.status);
  };

  const selfListing = allListings?.find((item) => item.id === activeListingId);
  const counterPartyListing = matchmakingData?.matches?.find(
    (item) => item && item.id === counterPartyListingId,
  );
  function parseDate(dateStr) {
    if (!dateStr) return 0;
    const formatted = dateStr.replace(/(\d{2})-(\w{3})-(\d{4})/, "$1 $2 $3");
    return Date.parse(formatted);
  }

  function parseDateFromDDMMYYYY(dateStr) {
    if (!dateStr) return new Date(0);
    const monthNames = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    };
    const [day, monthName, year] = dateStr.split("-");
    const month = monthNames[monthName];
    return new Date(parseInt(year), month, parseInt(day));
  }

  const normalizeStatus = (status) => {
    if (!status) return "";
    const s = status.toUpperCase();
    if (s === "TERMS_ACCEPTED") return "ACCEPTED";
    if (s === "COMPLETED") return "ONGOING";
    if (s === "HOLD") return "HOLD";
    if (s === "ACTIVE") return "ACTIVE";
    if (s === "PLACED") return "PLACED";
    if (s === "RECEIVED") return "RECEIVED";
    if (s === "LEDGER") return "LEDGER";
    return s;
  };

  const filteredAvailableMatches = useMemo(() => {
    let matches = (matchmakingData?.matches || []).filter(
      (match) => match != null,
    );

    if (
      activeListingId &&
      matchmakingData?.selfListing?.id &&
      matchmakingData.selfListing.id !== activeListingId
    ) {
      return [];
    }

    if (activeFilter && activeFilter !== "ALL" && activeFilter !== "HOLD") {
      matches = matches.filter((match) => {
        const normalizedStatus = normalizeStatus(match.status);
        if (activeFilter === "ACTIVE") {
          return ["ACTIVE", "PLACED", "RECEIVED", "LEDGER"].includes(
            normalizedStatus,
          );
        }
        return normalizedStatus === activeFilter;
      });
    }

    if (appliedFilters) {
      matches = matches.filter((match) => {
        if (appliedFilters.quantityRange) {
          const minQuantity =
            match.minInjectQuantity || match.minDrawalQuantity || 0;
          const maxQuantity =
            match.maxInjectQuantity || match.maxDrawalQuantity || 0;
          const quantity = Math.max(minQuantity, maxQuantity) || 0;
          if (
            quantity < appliedFilters.quantityRange[0] ||
            quantity > appliedFilters.quantityRange[1]
          ) {
            return false;
          }
        }

        if (appliedFilters.settlementRateRange) {
          const settlementRateStr = match.settlementRate || "";
          const settlementRateMatch =
            settlementRateStr.match(/DAM([+-]?)(\d+)/);
          let settlementRate = 0;
          if (settlementRateMatch) {
            const sign = settlementRateMatch[1] === "-" ? -1 : 1;
            settlementRate = sign * parseInt(settlementRateMatch[2], 10);
          }
          if (
            settlementRate < appliedFilters.settlementRateRange[0] ||
            settlementRate > appliedFilters.settlementRateRange[1]
          ) {
            return false;
          }
        }

        if (appliedFilters.bankingFactorRange) {
          const bankingFactor = match.bankingFactor || 0;
          if (
            bankingFactor < appliedFilters.bankingFactorRange[0] ||
            bankingFactor > appliedFilters.bankingFactorRange[1]
          ) {
            return false;
          }
        }

        if (
          appliedFilters.selectedCreditRating &&
          appliedFilters.selectedCreditRating !== ""
        ) {
          const creditRating =
            match.companyDetails?.creditRating || match.creditRating;

          let selectedRatingValue = appliedFilters.selectedCreditRating;
          if (
            typeof appliedFilters.selectedCreditRating === "object" &&
            appliedFilters.selectedCreditRating !== null
          ) {
            selectedRatingValue =
              appliedFilters.selectedCreditRating.rating ||
              appliedFilters.selectedCreditRating.name ||
              appliedFilters.selectedCreditRating.value ||
              appliedFilters.selectedCreditRating.level ||
              appliedFilters.selectedCreditRating.type ||
              appliedFilters.selectedCreditRating.acronym ||
              appliedFilters.selectedCreditRating.id ||
              String(appliedFilters.selectedCreditRating);
          }

          if (!creditRating && !selectedRatingValue) {
            return true;
          }

          if (!creditRating || !selectedRatingValue) {
            return false;
          }

          const normalizedCreditRating = String(creditRating)
            .trim()
            .toUpperCase();
          const normalizedSelectedValue = String(selectedRatingValue)
            .trim()
            .toUpperCase();

          if (normalizedCreditRating === normalizedSelectedValue) {
            return true;
          }
          return false;
        }

        if (appliedFilters.injectionModals) {
          const hasInjectionQuantityFilter =
            appliedFilters.injectionModals.some((modalGroup) =>
              modalGroup.some(
                (injectionFilter) =>
                  injectionFilter.quantity && injectionFilter.quantity !== "",
              ),
            );

          if (hasInjectionQuantityFilter) {
            const injectionQuantities = [];
            appliedFilters.injectionModals.forEach((modalGroup) => {
              modalGroup.forEach((injectionFilter) => {
                if (
                  injectionFilter.quantity &&
                  injectionFilter.quantity !== ""
                ) {
                  const qty = parseFloat(injectionFilter.quantity);
                  if (!isNaN(qty) && qty >= 0 && qty <= 10000) {
                    injectionQuantities.push(qty);
                  }
                }
              });
            });

            const hasMatchingInjectionQuantity = injectionQuantities.some(
              (filterQuantity) => {
                return match.bankingSlotInjects?.some((slot) => {
                  const slotRequiredQty = slot.requiredQty || 0;

                  return slotRequiredQty >= filterQuantity;
                });
              },
            );

            if (!hasMatchingInjectionQuantity) {
              return false;
            }
          }

          let hasInjectionDateTimeFilters = false;
          let matchesInjectionDateTimeFilters = false;

          for (let modalGroup of appliedFilters.injectionModals) {
            for (let injectionFilter of modalGroup) {
              if (
                injectionFilter.startDate ||
                injectionFilter.endDate ||
                injectionFilter.startTime ||
                injectionFilter.endTime
              ) {
                hasInjectionDateTimeFilters = true;

                if (
                  !match.bankingSlotInjects ||
                  match.bankingSlotInjects.length === 0
                ) {
                  continue;
                }

                const matchingInjectionSlot = match.bankingSlotInjects.some(
                  (slot) => {
                    let dateMatches = true;
                    let timeMatches = true;

                    const filterStartDate = injectionFilter.startDate
                      ? parseDateFromDDMMYYYY(injectionFilter.startDate)
                      : null;
                    const filterEndDate = injectionFilter.endDate
                      ? parseDateFromDDMMYYYY(injectionFilter.endDate)
                      : null;
                    const slotStartDate = slot.dateStartAt
                      ? parseDateFromDDMMYYYY(slot.dateStartAt)
                      : null;
                    const slotEndDate = slot.dateEndAt
                      ? parseDateFromDDMMYYYY(slot.dateEndAt)
                      : null;

                    if (filterStartDate || filterEndDate) {
                      if (filterStartDate && !filterEndDate) {
                        const withinRange =
                          filterStartDate >= slotStartDate &&
                          filterStartDate <= slotEndDate;

                        dateMatches = withinRange;
                      } else if (!filterStartDate && filterEndDate) {
                        const withinRange =
                          filterEndDate >= slotStartDate &&
                          filterEndDate <= slotEndDate;

                        dateMatches = withinRange;
                      } else if (filterStartDate && filterEndDate) {
                        const strictContainment =
                          slotStartDate >= filterStartDate &&
                          slotEndDate <= filterEndDate;

                        const hasOverlap = !(
                          filterStartDate > slotEndDate ||
                          filterEndDate < slotStartDate
                        );

                        dateMatches = strictContainment || hasOverlap;
                      }
                    }

                    if (injectionFilter.startTime || injectionFilter.endTime) {
                      const filterStartTime =
                        injectionFilter.startTime || "00:00";
                      const filterEndTime = injectionFilter.endTime || "24:00";
                      const slotStartTime = slot.slotStartAt || "00:00";
                      const slotEndTime = slot.slotEndAt || "24:00";

                      const hasTimeOverlap =
                        filterStartTime < slotEndTime &&
                        slotStartTime < filterEndTime;

                      timeMatches = hasTimeOverlap;
                    }

                    let slotMatches = true;

                    if (injectionFilter.startDate || injectionFilter.endDate) {
                      slotMatches = slotMatches && dateMatches;
                    }

                    if (injectionFilter.startTime || injectionFilter.endTime) {
                      slotMatches = slotMatches && timeMatches;
                    }

                    return slotMatches;
                  },
                );

                if (matchingInjectionSlot) {
                  matchesInjectionDateTimeFilters = true;
                  break;
                }
              }
            }
            if (matchesInjectionDateTimeFilters) {
              break;
            }
          }

          if (hasInjectionDateTimeFilters && !matchesInjectionDateTimeFilters) {
            return false;
          }
        }

        if (appliedFilters.drawalModals) {
          const hasDrawalQuantityFilter = appliedFilters.drawalModals.some(
            (modalGroup) =>
              modalGroup.some(
                (drawalFilter) =>
                  drawalFilter.quantity && drawalFilter.quantity !== "",
              ),
          );

          if (hasDrawalQuantityFilter) {
            const drawalQuantities = [];
            appliedFilters.drawalModals.forEach((modalGroup) => {
              modalGroup.forEach((drawalFilter) => {
                if (drawalFilter.quantity && drawalFilter.quantity !== "") {
                  const qty = parseFloat(drawalFilter.quantity);
                  if (!isNaN(qty) && qty >= 0 && qty <= 10000) {
                    drawalQuantities.push(qty);
                  }
                }
              });
            });

            const hasMatchingDrawalQuantity = drawalQuantities.some(
              (filterQuantity) => {
                return match.bankingSlotDrawls?.some((slot) => {
                  const slotRequiredQty = slot.requiredQty || 0;

                  return slotRequiredQty >= filterQuantity;
                });
              },
            );

            if (!hasMatchingDrawalQuantity) {
              return false;
            }
          }

          let hasDrawalDateTimeFilters = false;
          let matchesDrawalDateTimeFilters = false;

          for (let modalGroup of appliedFilters.drawalModals) {
            for (let drawalFilter of modalGroup) {
              if (
                drawalFilter.startDate ||
                drawalFilter.endDate ||
                drawalFilter.startTime ||
                drawalFilter.endTime
              ) {
                hasDrawalDateTimeFilters = true;

                if (
                  !match.bankingSlotDrawls ||
                  match.bankingSlotDrawls.length === 0
                ) {
                  continue;
                }

                const matchingDrawalSlot = match.bankingSlotDrawls.some(
                  (slot) => {
                    let dateMatches = true;
                    let timeMatches = true;

                    if (drawalFilter.startDate || drawalFilter.endDate) {
                      const filterStartDate = drawalFilter.startDate
                        ? new Date(drawalFilter.startDate)
                        : null;
                      const filterEndDate = drawalFilter.endDate
                        ? new Date(drawalFilter.endDate)
                        : null;
                      const slotStartDate = parseDateFromDDMMYYYY(
                        slot.dateStartAt,
                      );
                      const slotEndDate = parseDateFromDDMMYYYY(slot.dateEndAt);

                      if (filterStartDate && !filterEndDate) {
                        const withinRange =
                          filterStartDate >= slotStartDate &&
                          filterStartDate <= slotEndDate;

                        dateMatches = withinRange;
                      } else if (!filterStartDate && filterEndDate) {
                        const withinRange =
                          filterEndDate >= slotStartDate &&
                          filterEndDate <= slotEndDate;

                        dateMatches = withinRange;
                      } else if (filterStartDate && filterEndDate) {
                        const strictContainment =
                          slotStartDate >= filterStartDate &&
                          slotEndDate <= filterEndDate;

                        const hasOverlap = !(
                          filterStartDate > slotEndDate ||
                          filterEndDate < slotStartDate
                        );

                        dateMatches = strictContainment || hasOverlap;
                      }
                    }

                    if (drawalFilter.startTime || drawalFilter.endTime) {
                      const filterStartTime = drawalFilter.startTime || "00:00";
                      const filterEndTime = drawalFilter.endTime || "24:00";
                      const slotStartTime = slot.slotStartAt || "00:00";
                      const slotEndTime = slot.slotEndAt || "24:00";

                      const hasTimeOverlap =
                        filterStartTime < slotEndTime &&
                        slotStartTime < filterEndTime;

                      timeMatches = hasTimeOverlap;
                    }

                    let slotMatches = true;

                    if (drawalFilter.startDate || drawalFilter.endDate) {
                      slotMatches = slotMatches && dateMatches;
                    }

                    if (drawalFilter.startTime || drawalFilter.endTime) {
                      slotMatches = slotMatches && timeMatches;
                    }

                    return slotMatches;
                  },
                );

                if (matchingDrawalSlot) {
                  matchesDrawalDateTimeFilters = true;
                  break;
                }
              }
            }
            if (matchesDrawalDateTimeFilters) {
              break;
            }
          }

          if (hasDrawalDateTimeFilters && !matchesDrawalDateTimeFilters) {
            return false;
          }
        }

        return true;
      });
    }

    return matches;
  }, [
    matchmakingData?.matches,
    matchmakingData?.selfListing?.id,
    activeListingId,
    activeFilter,
    appliedFilters,
  ]);

  const sortedFilteredMatches = useMemo(() => {
    // Status priority mapping: lower number = higher priority
    const getStatusPriority = (status, connectionStatus, isInitiator) => {
      const normalizedStatus = normalizeStatus(status);
      const normalizedConnectionStatus = normalizeStatus(connectionStatus);

      if (normalizedConnectionStatus === "TERMS_INITIATED" && !isInitiator) {
        return 0;
      }
      if (
        normalizedConnectionStatus === "TERMS_INITIATED" ||
        normalizedConnectionStatus === "TERMS_ACCEPTED"
      )
        return 1;
      if (normalizedStatus === "LEDGER") return 1;

      if (normalizedStatus === "PLACED" || normalizedStatus === "RECEIVED")
        return 2;

      if (normalizedStatus === "ACTIVE") return 3;
      return 4;
    };

    const sorted = [...filteredAvailableMatches].sort((a, b) => {
      // If expirySortDir is set, prioritize expiry date sorting
      if (expirySortDir) {
        const aDate = parseDate(a.expiryAt);
        const bDate = parseDate(b.expiryAt);
        const dateComparison =
          expirySortDir === "asc" ? aDate - bDate : bDate - aDate;

        // If dates are different, use date sorting
        if (dateComparison !== 0) {
          return dateComparison;
        }

        // If dates are same, use status priority as secondary
        const aPriority = getStatusPriority(
          a.status,
          a.connectionDetails?.[0]?.status,
        );
        const bPriority = getStatusPriority(
          b.status,
          b.connectionDetails?.[0]?.status,
        );
        return aPriority - bPriority;
      }

      // Default: sort by status priority only
      const aPriority = getStatusPriority(
        a.status,
        a.connectionDetails?.[0]?.status,
      );
      const bPriority = getStatusPriority(
        b.status,
        b.connectionDetails?.[0]?.status,
      );
      return aPriority - bPriority;
    });

    return sorted;
  }, [filteredAvailableMatches, expirySortDir]);

  const handleOpenIndent = (listing) => {
    setSelectedListing(listing);
    setIndentsModal(true);
  };

  const handleCloseIndent = () => {
    setIndentsModal(false);
  };

  const handleViewDocument = async (docId) => {
    if (!docId) {
      return;
    }

    try {
      const resultAction = await dispatch(fetchDocumentUrlByLedgerId(docId));
      if (fetchDocumentUrlByLedgerId.fulfilled.match(resultAction)) {
        const url = resultAction.payload?.url || resultAction.payload;
        if (url) {
          setPreviewFileUrl(url);
          setPreviewDocumentId(docId);
          setPreviewOpen(true);
        } else {
        }
      } else {
      }
    } catch (error) {}
  };

  const formatEndTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr.startsWith("23:59") ? "24:00" : timeStr;
  };

  React.useEffect(() => {
    setSelectedListing(null);
  }, [selfListings, activeFilter]);

  React.useEffect(() => {
    if (onCountChange && typeof onCountChange === "function") {
      onCountChange(sortedFilteredMatches.length);
    }
  }, [sortedFilteredMatches.length, onCountChange]);

  React.useEffect(() => {
    const calculateCloseableConnections = () => {
      const newCloseableConnections = new Set();

      if (sortedFilteredMatches.length > 0) {
        for (const item of sortedFilteredMatches) {
          try {
            const connectionDetails = getActiveConnectionDetails(item);

            if (connectionDetails) {
              const counterpartiesArray =
                connectionDetails.connection?.counterPartyListings || [];

              if (canShowClose(counterpartiesArray)) {
                const connectionId =
                  item.connectionDetails?.[0]?.id ||
                  connectionDetails.connection?.id;
                if (connectionId) {
                  newCloseableConnections.add(connectionId);
                }
              }
            }
          } catch (error) {}
        }
      }

      setCloseableConnections(newCloseableConnections);
    };

    const calculateLedgerActiveConnections = () => {
      const newLedgerActiveConnections = new Set();

      if (sortedFilteredMatches.length > 0) {
        for (const item of sortedFilteredMatches) {
          try {
            const connectionDetails = getActiveConnectionDetails(item);

            if (connectionDetails) {
              const counterpartiesArray =
                connectionDetails.connection?.counterPartyListings || [];

              if (canShowLedger(counterpartiesArray)) {
                const connectionId =
                  item.connectionDetails?.[0]?.id ||
                  connectionDetails.connection?.id;
                if (connectionId) {
                  newLedgerActiveConnections.add(connectionId);
                }
              }
            }
          } catch (error) {}
        }
      }

      setLedgerActiveConnections(newLedgerActiveConnections);
    };

    calculateCloseableConnections();
    calculateLedgerActiveConnections();
  }, [
    sortedFilteredMatches,
    canShowClose,
    canShowLedger,
    getActiveConnectionDetails,
  ]);

  const handleLedgerAction = (item, actionType = "finalize") => {
    try {
      const connectionDetails = getActiveConnectionDetails(item);

      if (!connectionDetails) {
        if (actionType === "finalize") {
          const connectionDetail = item.connectionDetails?.[0];

          if (connectionDetail) {
            const connection = {
              id: connectionDetail?.id || item?.id,
              selfListing: item,
              counterPartyListings: [
                {
                  id: item?.id,
                  name: item?.name,
                  companyName: item?.companyName,
                  userId: item?.userId,
                  connectionId: connectionDetail?.id,
                  connectionStatus: item?.status,
                  ...connectionDetail,
                },
              ],
            };

            const counterparty = {
              id: item?.id,
              name: item?.name,
              companyName: item?.companyName,
              userId: item?.userId,
              connectionId: connectionDetail?.id,
              connectionStatus: item?.status,
              bankingFactor: item?.bankingFactor,
              settlementRate: item?.settlementRate,
              maxInjectQuantity: item?.maxInjectQuantity,
              minInjectQuantity: item?.minInjectQuantity,
              maxDrawalQuantity: item?.maxDrawalQuantity,
              minDrawalQuantity: item?.minDrawalQuantity,
              bankingSlotInjects: item?.bankingSlotInjects,
              bankingSlotDrawls: item?.bankingSlotDrawls,
              injectMaxRange: item?.injectMaxRange,
              injectMinRange: item?.injectMinRange,
              drawalMaxRange: item?.drawalMaxRange,
              drawalMinRange: item?.drawalMinRange,
              ...connectionDetail,
            };

            handleOpenModal(connection, counterparty, {
              viewOnly: false,
              isApprovalMode: false,
            });
          } else {
            const minimalConnection = {
              id: item?.id,
              selfListing: item,
              counterPartyListings: [
                {
                  id: item?.id,
                  name: item?.name,
                  companyName: item?.companyName,
                  userId: item?.userId,
                  connectionStatus: item?.status,
                },
              ],
            };

            const minimalCounterparty = {
              id: item?.id,
              name: item?.name,
              companyName: item?.companyName,
              userId: item?.userId,
              connectionStatus: item?.status,
              bankingFactor: item?.bankingFactor,
              settlementRate: item?.settlementRate,
              maxInjectQuantity: item?.maxInjectQuantity,
              minInjectQuantity: item?.minInjectQuantity,
              maxDrawalQuantity: item?.maxDrawalQuantity,
              minDrawalQuantity: item?.minDrawalQuantity,
              bankingSlotInjects: item?.bankingSlotInjects,
              bankingSlotDrawls: item?.bankingSlotDrawls,
              injectMaxRange: item?.injectMaxRange,
              injectMinRange: item?.injectMinRange,
              drawalMaxRange: item?.drawalMaxRange,
              drawalMinRange: item?.drawalMinRange,
            };

            handleOpenModal(minimalConnection, minimalCounterparty, {
              viewOnly: false,
              isApprovalMode: false,
            });
          }
        }
        return;
      }

      const { connection: conn, counterparty } = connectionDetails;

      if (!conn || !counterparty) {
        if (actionType === "finalize") {
        }
        return;
      }

      const userId = userData?.user?.user?.userId;
      const counterpartyUserId = counterparty.userId;
      const termsInitiatorId = counterparty?.termsInitiatorId;
      const connectionIsTermsInitiated =
        counterparty?.connectionStatus === "TERMS_INITIATED";

      const showApproveButton =
        connectionIsTermsInitiated &&
        termsInitiatorId &&
        userId !== termsInitiatorId &&
        userId !== counterpartyUserId;

      switch (actionType) {
        case "finalize":
          handleOpenModal(conn, counterparty, {
            viewOnly: false,
            isApprovalMode: false,
          });
          break;
        case "approve":
          if (showApproveButton) {
            handleOpenModal(conn, counterparty, {
              viewOnly: true,
              isApprovalMode: true,
            });
          }
          break;
        case "view":
          handleOpenModal(conn, counterparty, {
            viewOnly: true,
            isApprovalMode: false,
          });
          break;
        case "chat":
          handleChatOpen(
            activeListing?.name,
            item?.name,
            item?.connectionInitiatorListingId,
          );
          break;
        case "upload":
          handleUploadModalOpen(conn, counterparty);
          break;
        case "viewDoc":
          handleOpenViewDoc(counterparty?.connectionId, counterparty);
          break;
        default:
      }
    } catch (error) {
      const connectionDetail = item.connectionDetails?.[0];

      if (actionType === "finalize") {
        if (connectionDetail) {
          const connection = {
            id: connectionDetail.id || item.id,
            selfListing: item,
            counterPartyListings: [
              {
                id: item.id,
                name: item.name,
                companyName: item.companyName,
                userId: item.userId,
                connectionId: connectionDetail.id,
                connectionStatus: item.status,
                ...connectionDetail,
              },
            ],
          };

          const counterparty = {
            id: item.id,
            name: item.name,
            companyName: item.companyName,
            userId: item.userId,
            connectionId: connectionDetail.id,
            connectionStatus: item.status,
            bankingFactor: item.bankingFactor,
            settlementRate: item.settlementRate,
            maxInjectQuantity: item.maxInjectQuantity,
            minInjectQuantity: item.minInjectQuantity,
            maxDrawalQuantity: item.maxDrawalQuantity,
            minDrawalQuantity: item.minDrawalQuantity,
            bankingSlotInjects: item.bankingSlotInjects,
            bankingSlotDrawls: item.bankingSlotDrawls,
            injectMaxRange: item.injectMaxRange,
            injectMinRange: item.injectMinRange,
            drawalMaxRange: item.drawalMaxRange,
            drawalMinRange: item.drawalMinRange,
            ...connectionDetail,
          };

          handleOpenModal(connection, counterparty, {
            viewOnly: false,
            isApprovalMode: false,
          });
        } else {
          const minimalConnection = {
            id: item.id,
            selfListing: item,
            counterPartyListings: [
              {
                id: item.id,
                name: item.name,
                companyName: item.companyName,
                userId: item.userId,
                connectionStatus: item.status,
              },
            ],
          };

          const minimalCounterparty = {
            id: item.id,
            name: item.name,
            companyName: item.companyName,
            userId: item.userId,
            connectionStatus: item.status,
            bankingFactor: item.bankingFactor,
            settlementRate: item.settlementRate,
            maxInjectQuantity: item.maxInjectQuantity,
            minInjectQuantity: item.minInjectQuantity,
            maxDrawalQuantity: item.maxDrawalQuantity,
            minDrawalQuantity: item.minDrawalQuantity,
            bankingSlotInjects: item.bankingSlotInjects,
            bankingSlotDrawls: item.bankingSlotDrawls,
            injectMaxRange: item.injectMaxRange,
            injectMinRange: item.injectMinRange,
            drawalMaxRange: item.drawalMaxRange,
            drawalMinRange: item.drawalMinRange,
          };

          handleOpenModal(minimalConnection, minimalCounterparty, {
            viewOnly: false,
            isApprovalMode: false,
          });
        }
      } else if (actionType === "viewDoc") {
        const docConnectionId = connectionDetail?.id || item.id;
        const fallbackCounterparty = {
          id: item.id,
          name: item.name,
          companyName: item.companyName,
          userId: item.userId,
          connectionId: docConnectionId,
          connectionStatus: item.status,
          bankingFactor: item.bankingFactor,
          settlementRate: item.settlementRate,
          maxInjectQuantity: item.maxInjectQuantity,
          minInjectQuantity: item.minInjectQuantity,
          maxDrawalQuantity: item.maxDrawalQuantity,
          minDrawalQuantity: item.minDrawalQuantity,
          bankingSlotInjects: item.bankingSlotInjects,
          bankingSlotDrawls: item.bankingSlotDrawls,
          ...connectionDetail,
        };

        handleOpenViewDoc(docConnectionId, fallbackCounterparty);
      } else if (actionType === "chat") {
        handleChatOpen(
          activeListing?.name,
          item?.name,
          item?.connectionInitiatorListingId,
        );
      } else if (actionType === "upload") {
        const fallbackConnection = {
          id: connectionDetail?.id || item.id,
          selfListing: item,
          counterPartyListings: [
            {
              id: item.id,
              name: item.name,
              companyName: item.companyName,
              userId: item.userId,
              connectionStatus: item.status,
              ...connectionDetail,
            },
          ],
        };

        const fallbackCounterparty = {
          id: item.id,
          name: item.name,
          companyName: item.companyName,
          userId: item.userId,
          connectionId: connectionDetail?.id,
          connectionStatus: item.status,
          bankingFactor: item.bankingFactor,
          settlementRate: item.settlementRate,
          ...connectionDetail,
        };

        handleUploadModalOpen(fallbackConnection, fallbackCounterparty);
      }
    }
  };

  const LedgerActionButton = ({
    item,
    handleLedgerAction,
    styles,
    handleChatOpen,
  }) => {
    const [loading, setLoading] = useState(false);

    const handleButtonClick = () => {
      if (loading) return;

      setLoading(true);
      try {
        handleLedgerAction(item, "finalize");
      } catch (error) {}
      setLoading(false);
    };

    // eslint-disable-next-line no-unused-vars
    const connectionDetail = item.connectionDetails?.[0];
    // eslint-disable-next-line no-unused-vars
    const connection = getConnectionStatus(item.id);

    return (
      <div
        className={`display_flex_row_gap_8 ${styles.button_mainContainer}`}
        style={{ alignItems: "center" }}
      >
        {/* Chat Button */}
        {/* {
          <div
            className={Styles.chatBtn}
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleChatOpen(
                activeListing?.name,
                item?.name,
                item?.connectionInitiatorListingId,
              );
              // handlesetInitiatorListing({
              //   item: item,
              // });
            }}
          >
            Chat
          </div>
        } */}

        {/* Finalize T&C Button */}
        <div
          className={styles.otherBtn}
          onClick={handleButtonClick}
          style={{
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
          title="Finalize Terms and Conditions"
        >
          <div>{loading ? "Loading..." : "Finalize T&C"}</div>
        </div>
      </div>
    );
  };

  const handleOpenViewModalReceived = async (item) => {
    try {
      const resultAction = await dispatch(
        fetchBankingReceived({
          id: activeListingId,
          isInitiator: 0,
        }),
      );

      if (fetchBankingReceived.fulfilled.match(resultAction)) {
        const receivedData = resultAction.payload;

        const connectionRequest = receivedData?.received?.find(
          (receivedItem) =>
            receivedItem?.againstBankingListing?.id === item.id ||
            receivedItem?.bankingListing?.id === item.id,
        );

        if (connectionRequest) {
          setSelectedItem(connectionRequest);
          setViewModal(true);
        } else {
          const constructedData = {
            id: item.id,
            source: "RECEIVED",
            status: item.status || "INITIATED",
            bankingListing: selfListing,
            againstBankingListing: item,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };
          setSelectedItem(constructedData);
          setViewModal(true);
        }
      }
    } catch (error) {
      const constructedData = {
        id: item.id,
        source: "RECEIVED",
        status: item.status || "INITIATED",
        bankingListing: selfListing,
        againstBankingListing: item,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      setSelectedItem(constructedData);
      setViewModal(true);
    }
  };
  const handleOpenClosePopup = (connectionId) => {
    setSelectedConnectionId(connectionId);
    setIsClosePopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsClosePopupOpen(false);
    setSelectedConnectionId(null);
  };

  const handleConfirmClose = async () => {
    setLoading(true);
    try {
      await connectionClose(selectedConnectionId);

      setLoading(false);
      setIsClosePopupOpen(false);

      window.location.reload();
    } catch (error) {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  const handleViewProfileClick = (listingId) => {
    const listing = matches?.find((item) => item && item.id === listingId);
    if (listing) {
      setSelectedListing(listing);
      setViewProOpen(true);
    }
  };

  return (
    <>
      {connectModal.open && (
        <ConnectModalBanking
          open={connectModal.open}
          handleClose={handleCloseConnect}
          data={mixedMatches}
          selfData={matchmakingData?.selfListing}
          activeListingId={activeListingId}
          isConnectionAlreadyMade={connectModal.isConnected}
          selfListing={selfListing}
          counterPartyListing={counterPartyListing}
          handleOpenIndent={handleOpenIndent}
          activeFilter={activeFilter}
          onWithdrawSuccess={() => {
            setConnectModal({ open: false, isConnected: false });

            const isSafeToRefresh =
              activeListingId &&
              matchmakingData?.selfListing?.id === activeListingId &&
              activeLedgerData.length > 0;

            if (isSafeToRefresh) {
              fetchCombinedData();
            } else {
            }
          }}
        />
      )}

      {injectionOpen && (
        <ViewInjectionModal
          open={injectionOpen}
          handleClose={handleCloseInjection}
          data={injectData}
        />
      )}

      {drawalOpen && (
        <ViewDrawalModal
          open={drawalOpen}
          handleClose={handleCloseDrawal}
          data={drawalData}
        />
      )}

      <ViewInjectDrawal
        open={viewInjectDrawalOpen}
        handleClose={handleCloseViewInjectDrawal}
        data={viewInjectDrawalData}
        termsDocumentId={viewInjectDrawalData?.[0]?.termsDocumentId}
        onViewDocument={handleViewDocument}
      />
      {indentsModal && (
        <ViewInjectDrawal
          open={indentsModal}
          handleClose={handleCloseIndent}
          data={selectedListing ? [selectedListing] : []}
          activeListingId={selectedListing?.id}
          termsDocumentId={selectedListing?.termsDocumentId}
          onViewDocument={handleViewDocument}
        />
      )}
      <PreviewModal
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setPreviewFileUrl(null);
          setPreviewDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={previewDocumentId}
      />

      {viewModal && (
        <ViewModalReceived
          open={viewModal}
          handleClose={handleCloseView}
          data={selectedItem}
          refreshConnectionRequests={fetchCombinedData}
          requestsLoading={combinedLoading}
          onConnectionAccepted={handleConnectionAccepted}
          onConnectionDeclined={handleConnectionDeclined}
          initiatorListing={initiatorListing}
          mixedMatches={matchmakingData}
        />
      )}

      {/* Modal loading overlay */}
      {modalLoading && (
        <div className={Styles.loader_overlay}>
          <div className={Styles.loader_content}>
            <div className={Styles.energy_core}>
              <div className={Styles.ring}></div>
              <div className={Styles.ring}></div>
              <div className={Styles.ring}></div>
            </div>
          </div>
        </div>
      )}

      {termsModal && (
        <TermsConditionModal
          activeData={selectedConnection}
          activeCounterparty={selectedCounterparty}
          open={termsModal}
          handleClose={handleCloseModal}
          connectionId={
            selectedConnection?.id || selectedConnection?.connectionId
          }
          counterpartyId={selectedCounterparty?.id}
          onAccept={() => handleAccepted(selectedCounterparty?.id)}
          onDecline={() => handleDeclined(selectedCounterparty?.id)}
          currentUserListingIds={activeListingId}
          termsData={activeLedgerData}
          viewOnly={modalViewOnly}
          isApprovalMode={modalApprovalMode}
        />
      )}

      {/* {uploadModal && (
        <UploadDocModal
          open={uploadModal}
          handleClose={handleUploadClose}
          connectionId={
            selectedCounterparty?.connectionId || selectedConnection?.id
          }
          activeCounterparty={selectedCounterparty}
          onAllDocsUploaded={handleUploadClose}
          upData={activeLedgerData}
          agreementStatus={selectedCounterparty?.agreementStatus}
          isCounterparty={
            userData?.user?.user?.userId !==
            selectedCounterparty?.agreementInitiatorId
          }
        />
      )} */}

      {uploadModal && (
        <DirectDocumentation
          mode="banking"
          open={uploadModal}
          handleClose={handleUploadClose}
          connectionId={
            selectedCounterparty?.connectionId || selectedConnection?.id
          }
          activeCounterparty={selectedCounterparty}
          onAllDocsUploaded={handleUploadClose}
          upData={activeLedgerData}
          agreementStatus={selectedCounterparty?.agreementStatus}
          isCounterparty={
            userData?.user?.user?.userId !==
            selectedCounterparty?.agreementInitiatorId
          }
        />
      )}

      {viewDocModalOpen && (
        <ViewDoc
          open={viewDocModalOpen}
          handleClose={handleCloseViewDoc}
          connectionId={viewDocConnectionId}
          viewDocData={activeLedgerData}
          activeCounterparty={activeViewCounterparty}
        />
      )}

      {updateLedgerModalOpen && (
        <UpdateLedger
          open={updateLedgerModalOpen}
          handleClose={handleCloseUpdateLedger}
          connectionId={updateLedgerConnectionId}
          listingId={updateLedgerSelfListingId}
          connectionData={updateLedgerConnectionData}
          onLedgerUpdated={handleLedgerUpdated}
          activeListingId={activeListingId}
        />
      )}

      {/* Contract modal hidden — UpdateLedger modal is used instead
      {updateLedgerModalOpen && (
        <Modal open={updateLedgerModalOpen} onClose={handleCloseUpdateLedger}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95vw",
              maxWidth: "1300px",
              maxHeight: "90vh",
              overflow: "auto",
              backgroundColor: "#fff",
              borderRadius: "12px",
              outline: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "12px 16px 0",
              }}
            >
              <Close
                onClick={handleCloseUpdateLedger}
                style={{ cursor: "pointer" }}
              />
            </div>
            {/* TODO: replace hardcoded contractId with the real ledger/connection id */}
      {/* <ContractViewContainer />
          </div>
        </Modal>
      )} */}

      <ClosePopup
        open={isClosePopupOpen}
        handleClose={handleClosePopup}
        onConfirm={handleConfirmClose}
        loading={loading}
      />

      {viewProOpen && selectedListing && (
        <ViewProfile
          open={viewProOpen}
          data={selectedListing}
          connectionStatusRaw={
            selectedListing.connectionDetails &&
            selectedListing.connectionDetails.length > 0
              ? selectedListing.connectionDetails[0].status
              : selectedListing.status
          }
          handleClose={() => setViewProOpen(false)}
        />
      )}

      {combinedLoading ? (
        <AvailableListingSkeleton count={4} />
      ) : sortedFilteredMatches.length === 0 ? (
        <div className={` ${Styles.noDataMessage}`}>
          <NoDataPage />
        </div>
      ) : (
        sortedFilteredMatches?.map((item, index) => {
          if (!item) {
            return null;
          }

          const displayStatus =
            item.status === "TERMS_ACCEPTED"
              ? "ACCEPTED"
              : item.status === "HOLD"
                ? "ON HOLD"
                : item.status === "COMPLETED"
                  ? "ONGOING"
                  : item.status;

          const statusClass =
            item.status === "TERMS_ACCEPTED"
              ? Styles.acceptedStatus
              : item.status === "ONGOING" || item.status === "COMPLETED"
                ? Styles.ongoing
                : "";

          const statusDotClass =
            item.status === "TERMS_ACCEPTED"
              ? Styles.acceptedDot
              : item.status === "ONGOING" || item.status === "COMPLETED"
                ? Styles.ongoingDot
                : "";

          const isBankingRoute = window.location.pathname === "/banking";
          const ledgerConnectionDetails = getActiveConnectionDetails(item);
          const contractId =
            item?.connectionUniqueId ||
            item?.connectionDetails?.[0]?.connectionUniqueId ||
            item?.counterPartyListings?.[0]?.connectionUniqueId ||
            ledgerConnectionDetails?.counterparty?.connectionUniqueId ||
            ledgerConnectionDetails?.connection?.connectionUniqueId ||
            null;
          const isContractIdStatus =
            item?.status === "TERMS_ACCEPTED" ||
            item?.status === "COMPLETED" ||
            item?.status === "ONGOING";
          const showContractId =
            isBankingRoute && contractId && isContractIdStatus;

          return (
            <div
              key={index}
              className={`display_flex_column ${Styles.availableListingMainContainer}`}
            >
              <div
                className={`display_flex_row width_95_padding_5 ${Styles.availableListingHeader}`}
              >
                <div
                  className={`display_flex_row_gap_8 ${Styles.listHeaderName}`}
                >
                  {showContractId && (
                    <div className={Styles.contractIdLine} title={contractId}>
                      {"UID:"}{" "}
                      <span
                        className={Styles.contractValue}
                        style={{
                          color:
                            item?.isInjectionOnTop === false
                              ? "var(--secondary-color-text)"
                              : "var(--primary-color-text)",
                        }}
                      >
                        {contractId}
                      </span>
                    </div>
                  )}
                  {item?.status === "TERMS_ACCEPTED" ||
                  item?.status === "COMPLETED" ||
                  item?.status === "LEDGER" ||
                  item?.connectionDetails?.[0]?.status === "TERMS_INITIATED" ? (
                    <div className="display_flex_column_gap_4">
                      <span
                        style={{
                          textTransform: "uppercase",
                          color: "var(--secondary-color-text)",
                          fontWeight: "600",
                        }}
                      >
                        {item?.companyDetails?.displayName || "N/A"}
                      </span>
                      <span
                        style={{
                          fontSize: "8px",
                          color: "var(--secondary-color-text)",
                          fontWeight: "600",
                        }}
                      >
                        {item?.name || "N/A"}
                      </span>
                    </div>
                  ) : (
                    <span>{item?.name || "N/A"}</span>
                  )}

                  {/* {!hideViewProfile && (
                    <div
                      className={`display_flex_row_gap_8 ${Styles.availableSideHeader}`}
                    >
                      <span
                        className={Styles.viewPro}
                        onClick={() => {
                          setSelectedListing(item);
                          setViewProOpen(true);
                        }}
                      >
                        View Profile
                        <span>
                          <CallMadeIcon
                            style={{
                              width: "9px",
                              height: "9px",
                              marginBottom: "12px",
                            }}
                          />
                        </span>
                      </span>
                    </div>
                  )} */}
                  {item?.companyDetails?.creditRating &&
                    item?.companyDetails?.creditRating?.toUpperCase() !==
                      "UNKNOWN" && (
                      <span className={Styles.creditStyle}>
                        Credit Rating: {item?.companyDetails?.creditRating}
                      </span>
                    )}
                  {/* {(item.status === "TERMS_ACCEPTED" ||
                    item.status === "COMPLETED") && (
                    <span className={`${Styles.status} ${statusClass}`}>
                      <span
                        className={`${Styles.statusDot} ${statusDotClass}`}
                      ></span>
                      {displayStatus}
                    </span>
                  )} */}
                </div>

                {item.status === "TERMS_ACCEPTED" ||
                item.status === "COMPLETED" ? (
                  <>
                    {/* {(item.status === "TERMS_ACCEPTED" ||
                      item.status === "COMPLETED") && (
                      <span className={`${Styles.status} ${statusClass}`}>
                        <span
                          className={`${Styles.statusDot} ${statusDotClass}`}
                        ></span>
                        {displayStatus}
                      </span>
                    )} */}
                    <div
                      className={`display_flex_row_gap_8 ${Styles.listHeaderExpDate}`}
                    >
                      <AccessTimeIcon style={{ fontSize: "14px" }} />
                      <span className={`warning ${Styles.expirytext}`}>
                        Expires on
                      </span>
                      <span>
                        {item.expiryAt &&
                          (() => {
                            const [date, time] = item.expiryAt.split(" ");
                            return `${date.replace(/-/g, " ")} - ${time || ""}`;
                          })()}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={`display_flex_row_gap_8 ${Styles.listHeaderExpDate}`}
                    >
                      <AccessTimeIcon style={{ fontSize: "14px" }} />
                      <span className={`warning ${Styles.expirytext}`}>
                        Expires on
                      </span>
                      <span>
                        {item.expiryAt &&
                          (() => {
                            const [date, time] = item.expiryAt.split(" ");
                            return `${date.replace(/-/g, " ")} - ${time || ""}`;
                          })()}
                      </span>
                    </div>
                  </>
                )}
              </div>

              {/* Details */}
              <div
                className={`display_flex_row width_95_padding_5 ${Styles.availableListingDetails}`}
              >
                <div
                  className={`display_flex_row  ${Styles.availableListingDetailsSub}`}
                >
                  <div className="display_flex_column_gap_8">
                    <div>Injection Range</div>
                    <div className={Styles.drawalSection}>
                      <div>
                        {item.bankingSlotInjects?.[0]?.dateStartAt.replace(
                          /-/g,
                          " ",
                        )}{" "}
                        -{" "}
                        {item.bankingSlotInjects?.[0]?.dateEndAt.replace(
                          /-/g,
                          " ",
                        )}{" "}
                      </div>
                      <div>
                        {item.bankingSlotInjects?.[0]?.slotStartAt} -{" "}
                        {formatEndTime(item.bankingSlotInjects?.[0]?.slotEndAt)}
                      </div>
                    </div>
                  </div>

                  <div className="display_flex_column_gap_8">
                    <div className={Styles.headerInjectDrawal}>
                      Drawal Range
                    </div>
                    <div className={Styles.drawalSection}>
                      <div>
                        {" "}
                        {item.bankingSlotDrawls?.[0]?.dateStartAt.replace(
                          /-/g,
                          " ",
                        )}{" "}
                        -{" "}
                        {item.bankingSlotDrawls?.[0]?.dateEndAt.replace(
                          /-/g,
                          " ",
                        )}{" "}
                      </div>
                      <div>
                        {item.bankingSlotDrawls?.[0]?.slotStartAt} -{" "}
                        {formatEndTime(item.bankingSlotDrawls?.[0]?.slotEndAt)}
                      </div>
                    </div>
                  </div>

                  <div className="display_flex_column_gap_4">
                    <div>
                      BF <span style={{ fontSize: "10px" }}>(%)</span>
                    </div>
                    <div>{Number(item.bankingFactor).toFixed(2)}</div>
                  </div>

                  <div className="display_flex_column_gap_8">
                    <div>
                      SR <span style={{ fontSize: "10px" }}>(₹/kWh)</span>
                    </div>
                    <div>{item.settlementRate || 0}</div>
                  </div>
                </div>
                <div
                  className={Styles.viewAllIndButton}
                  onClick={() => handleOpenViewInjectDrawal(item)}
                >
                  View All Requisitions
                </div>
              </div>

              {/* Footer */}
              <div
                className={`width_95_padding_5 display_flex_row ${Styles.availableListingFooter}`}
              >
                <div
                  className={`display_flex_row_gap_8 ${Styles.availableListingFooterMain}`}
                >
                  <div
                    className={`display_flex_row ${Styles.availableListingFooterText} ${Styles.available_border}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (item.termsDocumentId) {
                        handleViewDocument(item.termsDocumentId);
                      }
                    }}
                    style={{
                      cursor: item.termsDocumentId ? "pointer" : "default",
                      opacity: item.termsDocumentId ? 1 : 0.6,
                    }}
                    title={
                      item.termsDocumentId
                        ? "View Terms & Conditions"
                        : "No T&C document available"
                    }
                  >
                    <span className={Styles.viewTCBtn}>
                      Specific T&C
                      <CallMadeIcon
                        style={{
                          color: "#8C8A96",
                          fontSize: "8px",
                          marginTop: "-20px",
                        }}
                      />
                    </span>
                  </div>

                  {(() => {
                    const connection = getConnectionStatus(item.id);
                    let connectionStatusRaw;
                    if (
                      item.connectionDetails &&
                      item.connectionDetails.length > 0
                    ) {
                      connectionStatusRaw = item.connectionDetails[0].status;
                    } else {
                      connectionStatusRaw = connection?.status;
                    }

                    const normalizeStatus = (status) => {
                      if (!status) return "";
                      const s = status.toUpperCase();
                      if (s === "TERMS_ACCEPTED") return "ACCEPTED";
                      if (s === "COMPLETED") return "ONGOING";
                      if (s === "HOLD") return "HOLD";
                      return s;
                    };

                    const connectionStatus =
                      normalizeStatus(connectionStatusRaw);

                    if (
                      connectionStatus === "TERMS_INITIATED" ||
                      connectionStatusRaw === "TERMS_ACCEPTED" ||
                      connectionStatusRaw === "COMPLETED" ||
                      connectionStatus === "ACCEPTED" ||
                      connectionStatus === "ONGOING"
                    ) {
                      const currentUserId = userData?.user?.user?.userId;
                      const connectionDetail = item.connectionDetails?.[0];
                      const termsInitiatorId =
                        connectionDetail?.termsInitiatorId ||
                        connection?.termsInitiatorId;
                      const isInitiater = currentUserId === termsInitiatorId;

                      // Agreement status/initiator are determined where needed below

                      return (
                        <>
                          {/* <div
                            className={`display_flex_row ${Styles.availableListingFooterText} ${Styles.available_border}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (connectionId) {
                                handleChatOpen(connectionId, companyName);
                              }
                            }}
                            style={{
                              cursor: connectionId ? "pointer" : "default",
                              opacity: connectionId ? 1 : 0.6,
                            }}
                            title="Open Chat"
                          >
                            <span className={Styles.chatBtn}>Chat</span>
                          </div> */}

                          {/* Show View Draft T&C for everyone unless Approve T&C is shown */}
                          {!(
                            connectionStatusRaw === "TERMS_INITIATED" &&
                            !isInitiater
                          ) && (
                            <div
                              className={Styles.viewTCBtn}
                              onClick={() => {
                                try {
                                  const connectionDetails =
                                    getActiveConnectionDetails(item);

                                  if (connectionDetails) {
                                    const { connection: conn, counterparty } =
                                      connectionDetails;
                                    handleOpenModal(conn, counterparty, {
                                      viewOnly: true,
                                      isApprovalMode: false,
                                    });
                                  } else {
                                    const connectionDetail =
                                      item.connectionDetails?.[0];
                                    if (connectionDetail) {
                                      const connection = {
                                        id: connectionDetail.id || item.id,
                                        selfListing: item,
                                        counterPartyListings: [
                                          {
                                            id: item.id,
                                            name: item.name,
                                            companyName: item.companyName,
                                            userId: item.userId,
                                            connectionId: connectionDetail.id,
                                            connectionStatus: item.status,
                                            ...connectionDetail,
                                          },
                                        ],
                                      };

                                      const counterparty = {
                                        id: item.id,
                                        name: item.name,
                                        companyName: item.companyName,
                                        userId: item.userId,
                                        connectionId: connectionDetail.id,
                                        connectionStatus: item.status,

                                        bankingFactor: item.bankingFactor,
                                        settlementRate: item.settlementRate,
                                        maxInjectQuantity:
                                          item.maxInjectQuantity,
                                        minInjectQuantity:
                                          item.minInjectQuantity,
                                        maxDrawalQuantity:
                                          item.maxDrawalQuantity,
                                        minDrawalQuantity:
                                          item.minDrawalQuantity,
                                        bankingSlotInjects:
                                          item.bankingSlotInjects,
                                        bankingSlotDrawls:
                                          item.bankingSlotDrawls,
                                        injectMaxRange: item.injectMaxRange,
                                        injectMinRange: item.injectMinRange,
                                        drawalMaxRange: item.drawalMaxRange,
                                        drawalMinRange: item.drawalMinRange,
                                        ...connectionDetail,
                                      };

                                      handleOpenModal(
                                        connection,
                                        counterparty,
                                        {
                                          viewOnly: true,
                                          isApprovalMode: false,
                                        },
                                      );
                                    } else {
                                      const minimalConnection = {
                                        id: item.id,
                                        selfListing: item,
                                      };

                                      const minimalCounterparty = {
                                        id: item.id,
                                        name: item.name,
                                        companyName: item.companyName,
                                        userId: item.userId,
                                        connectionStatus: item.status,
                                        bankingFactor: item.bankingFactor,
                                        settlementRate: item.settlementRate,
                                        maxInjectQuantity:
                                          item.maxInjectQuantity,
                                        minInjectQuantity:
                                          item.minInjectQuantity,
                                        maxDrawalQuantity:
                                          item.maxDrawalQuantity,
                                        minDrawalQuantity:
                                          item.minDrawalQuantity,
                                        bankingSlotInjects:
                                          item.bankingSlotInjects,
                                        bankingSlotDrawls:
                                          item.bankingSlotDrawls,
                                        injectMaxRange: item.injectMaxRange,
                                        injectMinRange: item.injectMinRange,
                                        drawalMaxRange: item.drawalMaxRange,
                                        drawalMinRange: item.drawalMinRange,
                                      };

                                      handleOpenModal(
                                        minimalConnection,
                                        minimalCounterparty,
                                        {
                                          viewOnly: true,
                                          isApprovalMode: false,
                                        },
                                      );
                                    }
                                  }
                                } catch (error) {}
                              }}
                            >
                              {connectionStatusRaw === "TERMS_ACCEPTED" ||
                              connectionStatusRaw === "COMPLETED" ||
                              connectionStatus === "ONGOING"
                                ? "View T&C"
                                : "View T&C"}
                              <span>
                                <CallMadeIcon
                                  style={{
                                    width: "9px",
                                    height: "9px",
                                    marginBottom: "15px",
                                  }}
                                />
                              </span>
                            </div>
                          )}

                          {/* {(connectionStatusRaw === "COMPLETED" ||
                            connectionStatus === "ONGOING") && (
                            <div
                              className={Styles.viewTCBtn}
                              onClick={() => {
                                try {
                                  const connectionDetails =
                                    getActiveConnectionDetails(item);

                                  if (connectionDetails) {
                                    const { connection: conn, counterparty } =
                                      connectionDetails;
                                    const connectionDetail =
                                      item.connectionDetails?.[0];
                                    const docConnectionId =
                                      connectionDetail?.id || conn?.id;
                                    handleOpenViewDoc(
                                      docConnectionId,
                                      counterparty,
                                    );
                                  } else {
                                    const connectionDetail =
                                      item.connectionDetails?.[0];
                                    const docConnectionId =
                                      connectionDetail?.id || item.id;
                                    const fallbackCounterparty = {
                                      id: item.id,
                                      name: item.name,
                                      companyName: item.companyName,
                                      userId: item.userId,
                                      connectionId: docConnectionId,
                                      connectionStatus: item.status,
                                      bankingFactor: item.bankingFactor,
                                      settlementRate: item.settlementRate,
                                      maxInjectQuantity: item.maxInjectQuantity,
                                      minInjectQuantity: item.minInjectQuantity,
                                      maxDrawalQuantity: item.maxDrawalQuantity,
                                      minDrawalQuantity: item.minDrawalQuantity,
                                      bankingSlotInjects:
                                        item.bankingSlotInjects,
                                      bankingSlotDrawls: item.bankingSlotDrawls,
                                      ...connectionDetail,
                                    };

                                    handleOpenViewDoc(
                                      docConnectionId,
                                      fallbackCounterparty,
                                    );
                                  }
                                } catch (error) {
                                  const connectionDetail =
                                    item.connectionDetails?.[0];
                                  const docConnectionId =
                                    connectionDetail?.id || item.id;

                                  const fallbackCounterparty = {
                                    id: item.id,
                                    name: item.name,
                                    companyName: item.companyName,
                                    userId: item.userId,
                                    connectionId: docConnectionId,
                                    connectionStatus: item.status,
                                    bankingFactor: item.bankingFactor,
                                    settlementRate: item.settlementRate,
                                    maxInjectQuantity: item.maxInjectQuantity,
                                    minInjectQuantity: item.minInjectQuantity,
                                    maxDrawalQuantity: item.maxDrawalQuantity,
                                    minDrawalQuantity: item.minDrawalQuantity,
                                    bankingSlotInjects: item.bankingSlotInjects,
                                    bankingSlotDrawls: item.bankingSlotDrawls,
                                    ...connectionDetail,
                                  };

                                  handleOpenViewDoc(
                                    docConnectionId,
                                    fallbackCounterparty,
                                  );
                                }
                              }}
                            >
                              View Doc
                              <span>
                                <CallMadeIcon
                                  style={{
                                    width: "9px",
                                    height: "9px",
                                    marginBottom: "15px",
                                  }}
                                />
                              </span>
                            </div>
                          )} */}

                          {connectionStatus === "ACCEPTED" &&
                            (() => {
                              try {
                                const connectionDetail =
                                  item.connectionDetails?.[0];
                                const currentUserId =
                                  userData?.user?.user?.userId;

                                let agreementInitiatorId, agreementStatus;
                                if (connectionDetail) {
                                  agreementInitiatorId =
                                    connectionDetail.agreementInitiatorId;
                                  agreementStatus =
                                    connectionDetail.agreementStatus;
                                } else if (connection) {
                                  agreementInitiatorId =
                                    connection.agreementInitiatorId;
                                  agreementStatus = connection.agreementStatus;
                                }

                                const isAgreementInitiator =
                                  currentUserId === agreementInitiatorId;
                                const showEditDocuments =
                                  isAgreementInitiator &&
                                  (agreementStatus === "UPLOADED" ||
                                    agreementStatus === "NOT_UPLOADED");

                                if (!showEditDocuments) return null;

                                return (
                                  <div
                                    className={Styles.viewTCBtn}
                                    onClick={() => {
                                      try {
                                        const connectionDetails =
                                          getActiveConnectionDetails(item);
                                        if (connectionDetails) {
                                          const {
                                            connection: conn,
                                            counterparty,
                                          } = connectionDetails;
                                          handleUploadModalOpen(
                                            conn,
                                            counterparty,
                                          );
                                        } else {
                                          const connectionDetail =
                                            item.connectionDetails?.[0];

                                          const fallbackConnection = {
                                            id: connectionDetail?.id || item.id,
                                            selfListing: item,
                                            counterPartyListings: [
                                              {
                                                id: item.id,
                                                name: item.name,
                                                companyName: item.companyName,
                                                userId: item.userId,
                                                connectionId:
                                                  connectionDetail?.id,
                                                connectionStatus: item.status,
                                                ...connectionDetail,
                                              },
                                            ],
                                          };

                                          const fallbackCounterparty = {
                                            id: item.id,
                                            name: item.name,
                                            companyName: item.companyName,
                                            userId: item.userId,
                                            connectionId: connectionDetail?.id,
                                            connectionStatus: item.status,
                                            bankingFactor: item.bankingFactor,
                                            settlementRate: item.settlementRate,
                                            maxInjectQuantity:
                                              item.maxInjectQuantity,
                                            minInjectQuantity:
                                              item.minInjectQuantity,
                                            maxDrawalQuantity:
                                              item.maxDrawalQuantity,
                                            minDrawalQuantity:
                                              item.minDrawalQuantity,
                                            bankingSlotInjects:
                                              item.bankingSlotInjects,
                                            bankingSlotDrawls:
                                              item.bankingSlotDrawls,
                                            ...connectionDetail,
                                          };

                                          handleUploadModalOpen(
                                            fallbackConnection,
                                            fallbackCounterparty,
                                          );
                                        }
                                      } catch (error) {
                                        const connectionDetail =
                                          item.connectionDetails?.[0];

                                        const fallbackConnection = {
                                          id: connectionDetail?.id || item.id,
                                          selfListing: item,
                                          counterPartyListings: [
                                            {
                                              id: item.id,
                                              name: item.name,
                                              companyName: item.companyName,
                                              userId: item.userId,
                                              connectionStatus: item.status,
                                            },
                                          ],
                                        };

                                        const fallbackCounterparty = {
                                          id: item.id,
                                          name: item.name,
                                          companyName: item.companyName,
                                          userId: item.userId,
                                          connectionStatus: item.status,
                                          bankingFactor: item.bankingFactor,
                                          settlementRate: item.settlementRate,
                                          ...connectionDetail,
                                        };

                                        handleUploadModalOpen(
                                          fallbackConnection,
                                          fallbackCounterparty,
                                        );
                                      }
                                    }}
                                  >
                                    Edit Documents
                                    <span>
                                      <CallMadeIcon
                                        style={{
                                          width: "9px",
                                          height: "9px",
                                          // paddingLeft: "6px",
                                          marginBottom: "15px",
                                        }}
                                      />
                                    </span>
                                  </div>
                                );
                              } catch (error) {
                                return null;
                              }
                            })()}
                        </>
                      );
                    }
                    return null;
                  })()}
                  {/* <div
                      className={`display_flex_row ${Styles.availableListingFooterText}`}
                    >
                      <span>View Profile</span>
                      <CallMadeIcon
                        style={{
                          color: "#8C8A96",
                          fontSize: "8px",
                          marginTop: "-10px",
                        }}
                      />
                    </div> */}
                </div>

                <div>
                  <div className={`display_flex_row_gap_8 `}>
                    {(() => {
                      const connection = getConnectionStatus(item.id);

                      let connectionStatusRaw;
                      if (
                        item.connectionDetails &&
                        item.connectionDetails.length > 0
                      ) {
                        connectionStatusRaw = item.connectionDetails[0].status;
                      } else {
                        connectionStatusRaw = connection?.status;
                      }

                      const normalizeStatus = (status) => {
                        if (!status) return "";
                        const s = status.toUpperCase();
                        if (s === "TERMS_ACCEPTED") return "ACCEPTED";
                        if (s === "COMPLETED") return "ONGOING";
                        if (s === "HOLD") return "HOLD";
                        return s;
                      };

                      const connectionStatus =
                        normalizeStatus(connectionStatusRaw);

                      const nonInteractiveStatuses = [
                        "ACCEPTED",
                        "ONGOING",
                        "HOLD",
                      ];

                      if (
                        connectionStatus &&
                        nonInteractiveStatuses.includes(connectionStatus)
                      ) {
                        if (
                          connectionStatusRaw === "TERMS_ACCEPTED" ||
                          connectionStatusRaw === "COMPLETED" ||
                          connectionStatus === "ACCEPTED" ||
                          connectionStatus === "ONGOING"
                        ) {
                          const connectionDetail = item.connectionDetails?.[0];

                          return (
                            <div
                              className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                            >
                              {/* {(connectionStatus === "LEDGER" ||
                                connectionStatus === "TERMS_INITIATED" ||
                                connectionStatusRaw === "TERMS_ACCEPTED" ||
                                connectionStatusRaw === "COMPLETED" ||
                                connectionStatus === "ACCEPTED" ||
                                connectionStatus === "ONGOING") && (
                                <div
                                  className={Styles.chatBtn}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleChatOpen(
                                      activeListing?.name,
                                      item?.name,
                                      item?.connectionInitiatorListingId,
                                    );
                                  }}
                                >
                                  Chat
                                </div>
                              )} */}
                              {/* <div
                                className="activeButton_type_2"
                                onClick={async () => {
                                  try {
                                    const connectionDetails =
                                      await getActiveConnectionDetails(item);
                                    if (connectionDetails) {
                                      const { connection: conn, counterparty } =
                                        connectionDetails;
                                      handleOpenModal(conn, counterparty, {
                                        viewOnly: true,
                                        isApprovalMode: false,
                                      });
                                    }
                                  } catch (error) {
                                  }
                                }}
                              >
                                View T&C
                              </div> */}
                              {(() => {
                                const currentUserId =
                                  userData?.user?.user?.userId;

                                let agreementInitiatorId, agreementStatus;
                                if (connectionDetail) {
                                  agreementInitiatorId =
                                    connectionDetail.agreementInitiatorId;
                                  agreementStatus =
                                    connectionDetail.agreementStatus;
                                } else if (connection) {
                                  agreementInitiatorId =
                                    connection.agreementInitiatorId;
                                  agreementStatus = connection.agreementStatus;
                                }

                                const isAgreementInitiator =
                                  currentUserId === agreementInitiatorId;

                                const showEditDocuments =
                                  isAgreementInitiator &&
                                  (agreementStatus === "UPLOADED" ||
                                    agreementStatus === "NOT_UPLOADED");

                                const showAcceptAgreement =
                                  !isAgreementInitiator &&
                                  agreementStatus === "UPLOADED";

                                // Documentation flow bypassed: terms acceptance
                                // now goes straight to the Ledger/Close buttons
                                // instead of routing through documentation.
                                // const showFinalButtons =
                                //   agreementStatus === "ACCEPTED";
                                const showFinalButtons = true;

                                if (showFinalButtons) {
                                  return (
                                    <div
                                      className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                    >
                                      {/* <div
                                        className="activeButton_type_2"
                                        onClick={async () => {
                                          try {
                                            const connectionDetails =
                                              await getActiveConnectionDetails(
                                                item
                                              );
                                            if (connectionDetails) {
                                              const {
                                                connection: conn,
                                                counterparty,
                                              } = connectionDetails;
                                              const docConnectionId =
                                                connectionDetail?.id ||
                                                conn?.id;
                                              handleOpenViewDoc(
                                                docConnectionId,
                                                counterparty
                                              );
                                            }
                                          } catch (error) {
                                          }
                                        }}
                                      >
                                        View Doc
                                      </div> */}
                                      {/* ledger commented code  */}
                                      {/* {(() => {
                                        const connectionId =
                                          connectionDetail?.id ||
                                          item.connectionDetails?.[0]?.id;
                                        const isLedgerActive =
                                          ledgerActiveConnections.has(
                                            connectionId,
                                          );

                                        return isLedgerActive ? (
                                          <div
                                            className={Styles.otherBtn}
                                            onClick={() => {
                                              try {
                                                const connectionDetails =
                                                  getActiveConnectionDetails(
                                                    item,
                                                  );
                                                if (connectionDetails) {
                                                  const { connection: conn } =
                                                    connectionDetails;
                                                  const ledgerConnectionId =
                                                    connectionDetail?.id ||
                                                    conn?.id;
                                                  const selfListingId =
                                                    matchmakingData?.selfListing
                                                      ?.id || activeListingId;

                                                  const counterPartyData =
                                                    connectionDetails?.counterparty;
                                                  const ledgers =
                                                    counterPartyData?.ledgers ||
                                                    [];

                                                  const connectionDataWithId = {
                                                    ...conn,
                                                    connectionId:
                                                      conn.id ||
                                                      ledgerConnectionId,
                                                    ledgers: ledgers,
                                                  };

                                                  handleOpenUpdateLedger(
                                                    ledgerConnectionId,
                                                    selfListingId,
                                                    connectionDataWithId,
                                                  );
                                                } else {
                                                  const connectionDetail =
                                                    item.connectionDetails?.[0];
                                                  const ledgerConnectionId =
                                                    connectionDetail?.id ||
                                                    item.id;
                                                  const selfListingId =
                                                    matchmakingData?.selfListing
                                                      ?.id || activeListingId;

                                                  const fallbackConnectionData =
                                                    {
                                                      id: ledgerConnectionId,
                                                      connectionId:
                                                        ledgerConnectionId,
                                                      selfListing: item,
                                                      counterPartyListings: [
                                                        {
                                                          id: item.id,
                                                          name: item.name,
                                                          companyName:
                                                            item.companyName,
                                                          userId: item.userId,
                                                          connectionStatus:
                                                            item.status,
                                                          ...connectionDetail,
                                                        },
                                                      ],
                                                      ledgers: [],
                                                    };

                                                  handleOpenUpdateLedger(
                                                    ledgerConnectionId,
                                                    selfListingId,
                                                    fallbackConnectionData,
                                                  );
                                                }
                                              } catch (error) {
                                                const connectionDetail =
                                                  item.connectionDetails?.[0];
                                                const ledgerConnectionId =
                                                  connectionDetail?.id ||
                                                  item.id;
                                                const selfListingId =
                                                  matchmakingData?.selfListing
                                                    ?.id || activeListingId;

                                                const fallbackConnectionData = {
                                                  id: ledgerConnectionId,
                                                  connectionId:
                                                    ledgerConnectionId,
                                                  selfListing: item,
                                                  counterPartyListings: [
                                                    {
                                                      id: item.id,
                                                      name: item.name,
                                                      companyName:
                                                        item.companyName,
                                                      userId: item.userId,
                                                      connectionStatus:
                                                        item.status,
                                                    },
                                                  ],
                                                  ledgers: [],
                                                };

                                                handleOpenUpdateLedger(
                                                  ledgerConnectionId,
                                                  selfListingId,
                                                  fallbackConnectionData,
                                                );
                                              }
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Ledger
                                          </div>
                                        ) : (
                                          <div
                                            className={Styles.closeBtn}
                                            title="Ledger will be enabled from the slot start date"
                                          >
                                            Ledger
                                          </div>
                                        );
                                      })()} */}
                                      {/* <div
                                        className={Styles.otherBtn}
                                        onClick={() => {
                                          try {
                                            const connectionDetails =
                                              getActiveConnectionDetails(item);
                                            if (connectionDetails) {
                                              const { connection: conn } =
                                                connectionDetails;
                                              const ledgerConnectionId =
                                                connectionDetail?.id ||
                                                conn?.id;
                                              const selfListingId =
                                                matchmakingData?.selfListing
                                                  ?.id || activeListingId;

                                              const counterPartyData =
                                                connectionDetails?.counterparty;
                                              const ledgers =
                                                counterPartyData?.ledgers || [];

                                              const connectionDataWithId = {
                                                ...conn,
                                                connectionId:
                                                  conn.id || ledgerConnectionId,
                                                ledgers: ledgers,
                                              };

                                              handleOpenUpdateLedger(
                                                ledgerConnectionId,
                                                selfListingId,
                                                connectionDataWithId
                                              );
                                            } else {
                                              const connectionDetail =
                                                item.connectionDetails?.[0];
                                              const ledgerConnectionId =
                                                connectionDetail?.id || item.id;
                                              const selfListingId =
                                                matchmakingData?.selfListing
                                                  ?.id || activeListingId;

                                              const fallbackConnectionData = {
                                                id: ledgerConnectionId,
                                                connectionId:
                                                  ledgerConnectionId,
                                                selfListing: item,
                                                counterPartyListings: [
                                                  {
                                                    id: item.id,
                                                    name: item.name,
                                                    companyName:
                                                      item.companyName,
                                                    userId: item.userId,
                                                    connectionStatus:
                                                      item.status,
                                                    ...connectionDetail,
                                                  },
                                                ],
                                                ledgers: [],
                                              };

                                              handleOpenUpdateLedger(
                                                ledgerConnectionId,
                                                selfListingId,
                                                fallbackConnectionData
                                              );
                                            }
                                          } catch (error) {

                                            // Additional fallback in catch block
                                            const connectionDetail =
                                              item.connectionDetails?.[0];
                                            const ledgerConnectionId =
                                              connectionDetail?.id || item.id;
                                            const selfListingId =
                                              matchmakingData?.selfListing
                                                ?.id || activeListingId;

                                            const fallbackConnectionData = {
                                              id: ledgerConnectionId,
                                              connectionId: ledgerConnectionId,
                                              selfListing: item,
                                              counterPartyListings: [
                                                {
                                                  id: item.id,
                                                  name: item.name,
                                                  companyName: item.companyName,
                                                  userId: item.userId,
                                                  connectionStatus: item.status,
                                                },
                                              ],
                                              ledgers: [],
                                            };

                                            handleOpenUpdateLedger(
                                              ledgerConnectionId,
                                              selfListingId,
                                              fallbackConnectionData
                                            );
                                          }
                                        }}
                                      >
                                        Ledger
                                      </div> */}
                                      {/* {(() => {
                                        const connectionId =
                                          connectionDetail?.id ||
                                          item.connectionDetails?.[0]?.id;
                                        const isCloseable =
                                          closeableConnections.has(
                                            connectionId,
                                          );

                                        return isCloseable ? (
                                          <div
                                            className={`activeButton ${Styles.closeBtn}`}
                                           
                                            onClick={() =>
                                              handleOpenClosePopup(connectionId)
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            Close
                                          </div>
                                        ) : (
                                          <div
                                            className={Styles.closeBtn}
                                            title="Close will be enabled after the slot end date"
                                          >
                                            Close
                                          </div>
                                        );
                                      })()} */}
                                    </div>
                                  );
                                }
                                // Documentation flow commented out — the branch
                                // above always renders Ledger/Close now.
                                // else if (showAcceptAgreement) {
                                //   return (
                                //     <div
                                //       className={Styles.otherBtn}
                                //       onClick={() =>
                                //         handleAcceptAgreementClick(item)
                                //       }
                                //     >
                                //       Accept Agreement
                                //     </div>
                                //   );
                                // } else if (showEditDocuments) {
                                //   return (
                                //     <div className={Styles.waitingStatusDocs}>
                                //       Waiting Docs Approval
                                //     </div>
                                //   );
                                // }
                                /* eslint-disable no-unreachable */
                                else if (false) {
                                  return (
                                    <div
                                      className={Styles.otherBtn}
                                      onClick={() => {
                                        try {
                                          const connectionDetails =
                                            getActiveConnectionDetails(item);
                                          if (connectionDetails) {
                                            const {
                                              connection: conn,
                                              counterparty,
                                            } = connectionDetails;
                                            handleUploadModalOpen(
                                              conn,
                                              counterparty,
                                            );
                                          } else {
                                            const connectionDetail =
                                              item.connectionDetails?.[0];

                                            const fallbackConnection = {
                                              id:
                                                connectionDetail?.id || item.id,
                                              selfListing: item,
                                              counterPartyListings: [
                                                {
                                                  id: item.id,
                                                  name: item.name,
                                                  companyName: item.companyName,
                                                  userId: item.userId,
                                                  connectionId:
                                                    connectionDetail?.id,
                                                  connectionStatus: item.status,
                                                  ...connectionDetail,
                                                },
                                              ],
                                            };

                                            const fallbackCounterparty = {
                                              id: item.id,
                                              name: item.name,
                                              companyName: item.companyName,
                                              userId: item.userId,
                                              connectionId:
                                                connectionDetail?.id,
                                              connectionStatus: item.status,
                                              bankingFactor: item.bankingFactor,
                                              settlementRate:
                                                item.settlementRate,
                                              ...connectionDetail,
                                            };

                                            handleUploadModalOpen(
                                              fallbackConnection,
                                              fallbackCounterparty,
                                            );
                                          }
                                        } catch (error) {
                                          // Additional fallback in catch block
                                          const connectionDetail =
                                            item.connectionDetails?.[0];

                                          const fallbackConnection = {
                                            id: connectionDetail?.id || item.id,
                                            selfListing: item,
                                            counterPartyListings: [
                                              {
                                                id: item.id,
                                                name: item.name,
                                                companyName: item.companyName,
                                                userId: item.userId,
                                                connectionStatus: item.status,
                                              },
                                            ],
                                          };

                                          const fallbackCounterparty = {
                                            id: item.id,
                                            name: item.name,
                                            companyName: item.companyName,
                                            userId: item.userId,
                                            connectionStatus: item.status,
                                            bankingFactor: item.bankingFactor,
                                            settlementRate: item.settlementRate,
                                            ...connectionDetail,
                                          };

                                          handleUploadModalOpen(
                                            fallbackConnection,
                                            fallbackCounterparty,
                                          );
                                        }
                                      }}
                                    >
                                      Documentation
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          );
                        } else {
                          const statusClass =
                            connectionStatus === "ONGOING"
                              ? Styles.statusOngoingDisplay
                              : Styles.statusDisplay;
                          return (
                            <div
                              className={statusClass}
                              style={{ cursor: "default" }}
                            >
                              {connectionStatus.replace(/_/g, " ")}
                            </div>
                          );
                        }
                      } else if (connectionStatus === "PLACED") {
                        return (
                          <div
                            className={Styles.viewConnectionBtn}
                            onClick={() =>
                              handleOpenConnect(
                                item,
                                isConnectionEstablished(item.id),
                              )
                            }
                          >
                            Connection Request
                          </div>
                        );
                      } else if (connectionStatus === "RECEIVED") {
                        return (
                          <div
                            className={Styles.receivedBtn}
                            // onClick={async () => {
                            //   try {
                            //     await dispatch(
                            //       fetchBankingReceived({
                            //         id: activeListingId,
                            //         isInitiator: 0,
                            //       })
                            //     );
                            //     navigate(`/bids_received_banking`, {
                            //       state: {
                            //         listingId: activeListingId,
                            //         listingName: selfListing?.name || "",
                            //       },
                            //     });
                            //   } catch (error) {
                            //     navigate(`/bids_received_banking`, {
                            //       state: {
                            //         listingId: activeListingId,
                            //         listingName: selfListing?.name || "",
                            //       },
                            //     });
                            //   }
                            // }}
                            onClick={() => {
                              setInitiatorListing(
                                item?.connectionInitiatorListingId,
                              );
                              setTimeout(() => {
                                handleOpenViewModalReceived(item);
                              }, 1000);
                            }}
                          >
                            Received Request
                          </div>
                        );
                      } else if (connectionStatus === "LEDGER") {
                        return (
                          <LedgerActionButton
                            item={item}
                            handleLedgerAction={handleLedgerAction}
                            styles={Styles}
                            handleChatOpen={handleChatOpen}
                          />
                        );
                      } else if (connectionStatus === "TERMS_INITIATED") {
                        const currentUserId = userData?.user?.user?.userId;
                        let termsInitiatorId;
                        if (
                          item.connectionDetails &&
                          item.connectionDetails.length > 0
                        ) {
                          termsInitiatorId =
                            item.connectionDetails[0].termsInitiatorId;
                        } else {
                          termsInitiatorId = connection?.termsInitiatorId;
                        }
                        const isInitiator = currentUserId === termsInitiatorId;
                        // eslint-disable-next-line no-unused-vars
                        const connectionDetail = item.connectionDetails?.[0];
                        return (
                          <>
                            {/* <div
                              className={Styles.chatBtn}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleChatOpen(
                                  activeListing?.name,
                                  item?.name,
                                  item?.connectionInitiatorListingId,
                                );
                              }}
                              title="Open Chat"
                            >
                              Chat
                            </div> */}
                            {isInitiator ? (
                              <div className={Styles.waitingStatusText}>
                                Waiting Terms Approval
                              </div>
                            ) : (
                              <div
                                className={Styles.otherBtn}
                                onClick={() => {
                                  try {
                                    const connectionDetails =
                                      getActiveConnectionDetails(item);

                                    if (connectionDetails) {
                                      const { connection: conn, counterparty } =
                                        connectionDetails;
                                      handleOpenModal(conn, counterparty, {
                                        viewOnly: true,
                                        isApprovalMode: true,
                                      });
                                    }
                                  } catch (error) {}
                                }}
                              >
                                Approve T&C
                              </div>
                            )}
                          </>
                        );
                      } else {
                        return (
                          <div
                            className={Styles.connectBtn}
                            onClick={() =>
                              handleOpenConnect(
                                item,
                                isConnectionEstablished(item.id),
                              )
                            }
                          >
                            <PersonAddAltIcon
                              style={{ fontSize: "16px", marginRight: "6px" }}
                            />
                            Connect
                          </div>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </>
  );
};

export default AvailableListing;
